module.exports = __webpack_public_path__ + "img/13_mathias-p-r-reding.fe32a80d.jpg";